import styled from 'styled-components';

export const GoodsList = styled.div`
  width: 1159px;
  height: 689px;
  padding-top: 70px;
  padding-bottom: 70px;
  box-sizing: border-box;

  position: relative;

  > .bg {
    position: absolute;
    z-index: -100;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background-image: url(${require('../img/bg.png')});
    background-size: 100% 100%;
  }

  > .close-button {
    width: 33px;
    height: 33px;
    right: 0;
    top: -7px;
    transform: translateY(-100%);
    position: absolute;

    /* border: 1px solid coral; */

    background-image: url(${require('../img/close.png')});
    background-size: 100% 100%;
  }

  > .title {
    position: absolute;
    display: block;
    left: 50%;
    transform: translateX(-50%);
    top: -32px;
  }

  > .title-bottom {
    position: absolute;
    display: block;
    left: 50%;
    transform: translateX(-50%);
    top: 25px;
    z-index: -10;
  }

  > .shop-block {
    position: absolute;
    bottom: -33px;
    left: 50%;
    transform: translateX(-50%);
    > .shop-name-block {
      width: 242px;
      height: 46px;
      margin-left: auto;
      margin-right: auto;
      position: relative;

      line-height: 46px;
      text-align: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(3, 6, 8, 1);

      > .bg {
        position: absolute;
        top: -8px;
        bottom: -8px;
        left: -8px;
        right: -8px;
        z-index: -1000;

        background-image: url(${require('../img/shop-name-bg.png')});
        background-size: 100% 100%;
      }
    }

    > .phone-block {
      width: 278px;
      height: 56px;

      position: relative;

      line-height: 56px;
      text-align: center;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(248, 34, 69, 1);

      > .bg {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1000;

        background-image: url(${require('../img/phone-bg.png')});
        background-size: 100% 100%;
      }
    }
  }
`;

export const Container = styled.div`
  box-sizing: border-box;
  padding-left: 24px;
  padding-right: 22px;

  height: 100%;
  overflow-y: scroll;

  /*控制整个滚动条*/
  ::-webkit-scrollbar {
    background-color: transparent;
    width: 6px;
    /* height: 10px; */
    background-clip: padding-box;
  }

  /*滚动条两端方向按钮*/
  ::-webkit-scrollbar-button {
    background-color: rgba(22, 251, 248, 1);
  }

  /*滚动条中间滑动部分*/
  ::-webkit-scrollbar-thumb {
    background-color: rgba(22, 251, 248, 1);
    border-radius: 5px;
  }

  /*滚动条右下角区域*/
  ::-webkit-scrollbar-corner {
    background-color: rgba(22, 251, 248, 1);
  }
`;

export const Goods = styled.div`
  padding-top: 28px;
  padding-bottom: 38px;
  padding-left: 43px;
  padding-right: 43px;
  box-sizing: border-box;

  display: flex;

  > .img-block {
    width: 188px;
    height: 188px;
    background: rgba(255, 255, 255, 1);

    display: flex;
    align-items: center;
    justify-content: center;

    > .img-wrapper {
      width: 152px;
      height: 174px;
      display: flex;
      align-items: center;
      justify-content: center;

      > .img {
        height: 100%;
      }
    }
  }

  > .info-block {
    margin-left: 28px;
    > .goods-name {
      width: 640px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(21, 12, 23, 1);

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > .current-price-floor {
      display: flex;
      align-items: center;
      margin-top: 21px;
      > .current-price {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(246, 14, 35, 1);
      }
      > .count {
        margin-left: 16px;

        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(110, 110, 110, 1);
      }
    }

    > .origin-price-floor {
      margin-top: 11px;

      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      text-decoration: line-through;
      color: rgba(187, 187, 187, 1);
    }

    > .specification-floor {
      margin-top: 25px;
      display: flex;
      flex-wrap: wrap;
      margin-left: -12px;
      margin-bottom: -16px;

      > .specification {
        box-sizing: border-box;
        padding: 6px 11px;
        border: 1px solid rgba(168, 168, 168, 1);

        display: flex;

        margin-left: 12px;
        margin-bottom: 16px;

        font-size: 12px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(146, 146, 146, 1);
      }
    }
  }
`;
